import {TextareaVariable} from '../types'
import {PILL_CLASS} from './constants'


// Construct the pill element for a single variable. The pill is a
// self-contained `chip` element (styled in editor-template.scss — it
// deliberately does NOT reuse the shared `ui5-chip` component) with two
// children:
//   - `.chip__icon icon <t.icon>` — the variable's own icon, the same
//     one shown for it in the Add-field popover
//   - `.chip__label`              — the visible label
// The chip is sized a touch smaller than the Add-field button in the
// toolbar above — small enough to read as inline tokens inside the
// running text.
//
// The BEM-scoped child classes (`__icon`, `__label`) avoid collisions
// with generic `.label` / `.icon` rules in surrounding views (e.g.
// `.automation-view .row .label` injects huge margins).
//
// `contenteditable="false"` makes the pill atomic to the browser's
// caret / Backspace handling — which is what gives us native-undo
// support without calling `execCommand`.
export function textareaWithVariables_buildPill(t: TextareaVariable): HTMLElement {
    const span = document.createElement('span')
    span.className = PILL_CLASS
    span.setAttribute('contenteditable', 'false')
    span.setAttribute('data-token', t.token)

    if (t.icon) {
        const iconEl = document.createElement('span')
        iconEl.className = `chip__icon icon ${t.icon}`
        span.appendChild(iconEl)
    }

    const labelEl = document.createElement('span')
    labelEl.className = 'chip__label'
    labelEl.textContent = t.label || t.token
    span.appendChild(labelEl)

    return span
}
